import React, { Fragment } from 'react';
import styled from '@emotion/styled';

import SpinnerBlock from '../../../common/SpinnerBlock';
import TableRow from './TableRow';
import numeral from 'numeral';
import { getCurrencySymbol } from '../../../../helpers';
import { SINGLE_BILL_THEAD_ITEMS } from '../../../../config';

const Wrapper = styled('div')`
  margin-top: 24px;
  .table {
    width: 100%;
    margin-bottom: 0;
    .tr-no-border td {
      border: none;
    }
    .bolder {
      font-weight: 700;
    }
  }
  .table tr {
    padding-top: 3px;
    padding-bottom: 3px;
    color: #323a46;
  }
  .table th {
    &.right {
      text-align: right;
    }
  }
  .table td {
    padding-bottom: 7px;
    padding-top: 7px;
    &.right {
      text-align: right;
    }
  }
  .table .thead-light th {
    padding-top: 9px;
    padding-bottom: 9px;
    span {
      font-weight: 500;
    }
  }
  strong {
    display: block;
    font-weight: 500;
  }
  .text-muted {
    color: #98a6ad;
  }
  .red {
    color: #f1556c;
  }
`;

const MainTable = (props) => {
  const { loading, item } = props;

  return (
    <>
      <Wrapper>
        <div className="fixed-table-container mb-3">
          <div className="fixed-table-body">
            <table className="table table-centered">
              <thead className="thead-light">
                <tr>
                  <Fragment>
                    {SINGLE_BILL_THEAD_ITEMS.map((item) => (
                      <th
                        className={item.align === 'right' ? 'right' : null}
                        colSpan={item.colSpan}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        {item.title}
                      </th>
                    ))}
                  </Fragment>
                </tr>
              </thead>
              {!loading ? (
                <tbody>
                  {item.items.map((item) => (
                    <TableRow item={item} key={item.id} />
                  ))}
                  <tr className="tr-no-border bolder">
                    <td colSpan="6"></td>
                    <td className="right">Итого:</td>
                    <td className="right" style={{ whiteSpace: 'nowrap' }}>{`${numeral(
                      +item.totalSum,
                    ).format('0,0.00')} ${getCurrencySymbol('RUB')}`}</td>
                  </tr>
                  <tr className="tr-no-border bolder">
                    <td colSpan="6"></td>
                    <td className="right">В том числе НДС:</td>
                    <td className="right" style={{ whiteSpace: 'nowrap' }}>{`${numeral(
                      +item.vatSum,
                    ).format('0,0.00')} ${getCurrencySymbol('RUB')}`}</td>
                  </tr>
                  <tr className="tr-no-border bolder">
                    <td colSpan="6"></td>
                    <td className="right">Всего к оплате:</td>
                    <td className="right" style={{ whiteSpace: 'nowrap' }}>{`${numeral(
                      +item.totalSum,
                    ).format('0,0.00')} ${getCurrencySymbol('RUB')}`}</td>
                  </tr>
                </tbody>
              ) : null}
            </table>
            {loading ? (
              <div style={{ width: '100%', position: 'relative', height: '150px ' }}>
                <SpinnerBlock show={loading} />
              </div>
            ) : null}
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default MainTable;
